export default {
  meta: {
    title: '新址评分',
  },
};
